/**
 * participantOptions.js
 * ----------------------
 * Canonical grade/role/t-shirt/dietary vocabularies for dancer registration —
 * shared between the public registration form (DancerRegistration.js) and
 * the admin participant screening table (EventRegistrationSection.js), so
 * the two can't drift apart the way the admin entry-style filter once did.
 *
 * Experience level isn't here — it's the same 5-value vocabulary as dance
 * entry level (see shared/entryOptions.js's LEVEL_OPTIONS), which is already
 * the shared source of truth for that list.
 */

export const GRADES = ['9', '10', '11', '12'];
export const ROLES = ['Dancer', 'Choreographer', 'Dancer and Choreographer'];
export const TSHIRT_SIZES = ['Unisex S', 'Unisex M', 'Unisex L', 'Unisex XL', 'Unisex 2XL'];

// The dietary field is stored as a comma-joined string of these tags (plus,
// for "Other", free text appended after "Other: ") — see DancerRegistration.js's
// toggleDietary/submit logic.
export const DIETARY_OPTIONS = ['Vegetarian', 'Vegan', 'Kosher', 'Halal', 'Gluten-free', 'Dairy-free', 'None', 'Other'];
